import React from 'react'
import { Box, Flex } from 'components/ds'
import styles from './index.module.css'

type Props = {
  size?: 'small' | 'medium' | 'large'
  color?: string
}

/**
 * Animated loading component.
 *
 * Displays three animated cube shapes that morph and stack, creating a loading effect.
 *
 * @param size - Size variant of the loader (default: 'medium')
 * @param color - Fill color for the shapes (default: 'white')
 */
const DiscoStackLoader = ({
  size = 'medium',
  color = 'black',
}: Props): React.ReactNode => {
  // Calculate dimensions based on size - maintaining aspect ratio
  const dimensions = {
    small: { width: 200, height: 100 },
    medium: { width: 300, height: 150 },
    large: { width: 640, height: 520 },
  }[size]

  return (
    <Flex
      direction="column"
      align="center"
      gap="4"
      data-testid="disco-stack-loader"
    >
      <Box
        position="relative"
        width={`${dimensions.width}px`}
        height={`${dimensions.height}px`}
      >
        <svg
          viewBox="0 0 1200 600"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          {/* Bottom Shape */}
          <g className={styles.bottomShape}>
            <path
              className={styles.bottomPath}
              fill={color}
              d="M 50.618 -70.534 L 50.75 70.678 L 191.054 70.428 L 190.884 -70.534 Z"
            />
          </g>

          {/* Middle Shape */}
          <g className={styles.middleShape}>
            <path
              className={styles.middlePath}
              fill={color}
              d="M 51.118 -70.497 L 50.75 70.678 L 191.054 70.428 L 190.884 -70.747 Z"
            />
          </g>

          {/* Top Shape */}
          <g className={styles.topShape}>
            <path
              className={styles.topPath}
              fill={color}
              d="M 191.054 70.428 L 190.883 -70.534 L 50.618 -70.534 L 50.251 70.678 Z"
            />
          </g>
        </svg>
      </Box>
    </Flex>
  )
}

export default DiscoStackLoader
